import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

moment.locale('pt-br')

class Timer extends Component {
  constructor (props) {
    super(props)
    this.state = { time: {}, seconds: this.props.duration }
    this.timer = 0
    this.startTimer = this.startTimer.bind(this)
    this.countDown = this.countDown.bind(this)
  }
  componentDidMount () {
    const timeLeftVar = this.secondsToTime(this.state.seconds)
    this.setState({timer : timeLeftVar}, () => {
      this.startTimer()
    })
    
  }

  secondsToTime (secs) {
    const hours = Math.floor(secs / (60 * 60))

    const divisorForMinutes = secs % (60 * 60)
    const minutes = Math.floor(divisorForMinutes / 60)

    const divisorForSeconds = divisorForMinutes % 60
    const second = Math.ceil(divisorForSeconds)
    const seconds = second < 10 ? `0${second}` : second
    const obj = {
      hours,
      minutes,
      seconds,
    }
    return obj
  }

  startTimer () {
    if (this.timer === 0) {
      this.timer = setInterval(this.countDown, 1000)
    }
  }

  countDown () {
    const seconds = this.state.seconds - 1
    this.setState({
      time: this.secondsToTime(seconds),
      seconds,
    })
    if (seconds === 0) {
      clearInterval(this.timer)
    }
  }

  render () {
    return (
      <div>
        <h1>{this.state.time.minutes}:{this.state.time.seconds}</h1>
      </div>
    )
  }
}

Timer.defaultProps = {
}

Timer.propTypes = {
  duration: PropTypes.number.isRequired,
}

export default Timer



// WEBPACK FOOTER //
// ./src/shared/components/Timer/index.js